<template>
    <nav class="module-menu">
        <div class="module-menu__items">
            <div
                class="module-menu__item" 
                v-for="(item, index) in module.items" 
                :key="index" 
                data-aos="fade-down"
                :data-aos-delay="50 * (index + 1)"
            >
                <a 
                    class="module-menu__link" 
                    :href="item.url"
                >
                    {{ item.title }}
                </a>
            </div>
        </div>

        <transition name="fade-right" appear>
            <Dropmenu v-if="isDropmenu" :dropmenuItems="module.items"></Dropmenu>
        </transition>
    </nav>
</template>

<script>
import Dropmenu from "../elements/Dropmenu.vue";
export default {
    name: "ModuleMenu",
    components: {
        Dropmenu
    },
    props: {
        module: {
            type: Object,
            required: true,
        }
    },
    computed: {
        isDropmenu() {
            return this.$store.getters.isDropmenu;
        }
    },
    methods: {
        clickHandle() {
            const menuElements = document.querySelectorAll(
                '.module-menu__link'
            );

            window.addEventListener('load', this.getHashFromLocation);
            
            Array.prototype.slice.call(menuElements).forEach(item =>
                item.addEventListener('click', e => {
                    const hash = item.hash.substr(1);
                    if (hash) {
                        e.preventDefault();
                        this.scrollToEl(hash);
                    }
                })
            );
        },   
        getHashFromLocation() {
            const hash = window.location.hash.substr(1);
            if(hash) {
                this.scrollToEl(hash);
            }
        },
        scrollToEl(hash) {
            const headerHeight = document.querySelector('.header').clientHeight;
            const elToScroll = document.getElementById(hash);
            const elToScrollPos = elToScroll ? elToScroll.getBoundingClientRect().top - headerHeight : null;
            const startPos = window.pageYOffset

            if(elToScroll) {
                window.scrollTo({
                    top: startPos + elToScrollPos,
                    behavior: 'smooth'
                });
            }
        }
    },
    mounted() {
        this.clickHandle();
    }
};
</script>